import * as z from 'zod';

export const addressForm = z.object({
    country: z.string().min(1),
    postCode: z.string().min(1),
    state: z.string().min(1),
    street: z.string().min(1),
    town: z.string().min(1),
});

export interface ICreateDeliveryAddressForm {
    country: string;
    postCode: string;
    state: string;
    street: string;
    town: string;
}